import { useCallback } from "react";
import type { FormStore } from "../../store/types";
import type { FieldId } from "../../types";

/**
 * フォームのバリデーション機能を提供するフック
 *
 * ストアのバリデーションアクションを呼び出すためのインターフェースを提供します。
 * バリデーションロジック自体はストア側に集約しています。
 */
export function useFormValidation({ store }: { store: FormStore }) {
  // 個別フィールドのバリデーション実行
  const validateFieldFn = useCallback(
    (fieldId: FieldId): Promise<boolean> => {
      // ストアのフィールドバリデーションを呼び出し
      return Promise.resolve(store.validateField(fieldId));
    },
    [store],
  );

  // 全フィールドバリデーション実行
  const validateAll = useCallback((): Promise<boolean> => {
    // ストアの全体バリデーションを呼び出し
    return Promise.resolve(store.validateAll());
  }, [store]);

  return {
    validateField: validateFieldFn,
    validateAll,
    errors: store.errors,
    hasErrors: store.errors.length > 0,
  };
}
